import React from 'react';
import ViewRepresentation from '@src/components/ViewRepresentation/ViewRepresentation';
import DefaultLayout from '@src/components/_layouts/Default/DefaultLayout';
import NowLoadingMessage from '@src/components/NowLoadingMessage/NowLoadingMessage';

const Chat = React.lazy(() => import('@views/chat/components/Chat'));

export default function ChatView() {
    return <React.Suspense fallback={<NowLoadingMessage/>}>
        <ViewRepresentation element={Chat} layout={DefaultLayout}/>
    </React.Suspense>;
}
